<template>
  <v-card
    max-width="100%"
    raised
    elevation="3"
    :to="
      !meetData.isDeleted
        ? `/meeting/${meetData.id}/search/tenant/${tenantId}`
        : ''
    "
  >
    <v-card-text>
      <v-row no-gutters>
        <v-col cols="12" sm="12" md="12" lg="12" class="px-3 pt-2 pb-1">
          <div class="overline">
            <v-icon color="darkCharcoal" right left size="20"
              >mdi-calendar-clock</v-icon
            >{{ getTimeDetails(meetData) }}
          </div>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="12" class="px-3 pb-2">
          <div class="pl-2">
            <h5 class="meeting-name">
              {{ getMeetingName(meetData.meetingName) }}
            </h5>
          </div>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="12"><v-divider></v-divider></v-col>
        <v-col cols="12" sm="12" md="12" lg="12" class="px-3">
          <v-row
            class="pl-4"
            no-gutters
            v-for="(topic, index) in meetData.topics"
            :key="index"
          >
            <v-col cols="12" sm="12" md="12" lg="12">
              <div class="ma-1">
                <h4>
                  {{ topic.agendaName }}
                </h4>
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="7"
              lg="8"
              class="pl-4 d-flex align-center"
            >
              <h3 class="topic-name">
                <ul class="ma-2">
                  <li>{{ topic.topicName }}</li>
                </ul>
              </h3>
            </v-col>
            <v-col cols="12" sm="12" md="5" lg="4" class="py-1">
              <div v-if="!topic.documents.length">
                <strong class="d-flex justify-center" style="font-size: 22px"
                  >-</strong
                >
              </div>
              <div v-else v-for="doc in topic.documents" :key="doc.documentId">
                <v-row no-gutters>
                  <a
                    v-if="$security.checkUserAccess('DownloadDocument')"
                    class="ml-3"
                    style="font-weight: 700"
                    @click.stop.prevent="onFileDownload(doc)"
                    >{{ doc.fileName }}</a
                  >
                </v-row>
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
              v-show="index !== meetData.topics.length - 1"
              ><v-divider></v-divider
            ></v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { Internationalization } from "@syncfusion/ej2-base";
import { formatDate } from "../../utils/util";
import { mapActions } from "vuex";
import { openDocument } from "@/utils/util";

export default {
  name: "TagSearch",
  data() {
    return {
      intl: new Internationalization(),
      page: 1,
      isloading: false,
      pageSize: 10,
    };
  },
  props: {
    meetData: Object,
  },
  computed: {
    tenantId() {
      return sessionStorage.getItem("tenantId");
    },
  },
  methods: {
    ...mapActions({
      downloadDocumentAPI: "document/downloadDocument",
    }),
    formatDate,
    onFileDownload,
    getMeetingName(name) {
      if (name && name.length > 150) {
        return name.slice(0, 150) + "...";
      } else {
        return name;
      }
    },
    getTimeDetails(mDetails) {
      return (
        this.intl.formatDate(new Date(mDetails.scheduletStartTimeInUTC), {
          type: "date",
          skeleton: "long",
        }) +
        " (" +
        this.intl.formatDate(new Date(mDetails.scheduletStartTimeInUTC), {
          skeleton: "hm",
        }) +
        " - " +
        this.intl.formatDate(new Date(mDetails.scheduledEndTimeInUTC), {
          skeleton: "hm",
        }) +
        ")"
      );
    },
  },
};
async function onFileDownload(file) {
  const params = {
    documentId: file.documentId,
    filename: file.fileName,
  };
  const res = await this.downloadDocumentAPI(params);
  var contentType = res.headers["content-type"];
  var blob = new Blob([res.data], { type: contentType });
  var url = window.URL.createObjectURL(blob);
  openDocument(url, file.fileName);
}
</script>

<style scoped>
.meeting-name {
  font-weight: 700;
  word-break: break-word;
  font-size: 16px;
  color: #333333;
}
.topic-name {
  color: #333333;
}
::v-deep .v-card__text {
  padding: 0px;
}
::v-deep .v-list-item {
  min-height: 0;
}
.overline {
  line-height: 18px !important;
  font-family: "Noto Sans JP" !important;
  font-size: 13px !important;
  color: #333333 !important;
}
</style>